export const freeTrialFlag = false
export const chlorophyllSplashScreen = true
